import React from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'

import { useSelector } from 'react-redux'
import { PRODUCT_AVAILABILITY } from '../../../../helpers/const'
import { selectLabel } from '../../../../flux/selectors/i18n'

const StyledText = styled.span(({ theme: { colors }, textColor }) => ({
  color: colors[textColor],
}))

const Availability = ({ availability }) => {
  const availabilityLabelTranslation = useSelector(selectLabel(`availability.${availability}`))

  return (
    <StyledText data-test="Availability" textColor={PRODUCT_AVAILABILITY[availability]?.color}>
      {availabilityLabelTranslation || availability}
    </StyledText>
  )
}

Availability.propTypes = {
  availability: PropTypes.string,
}

Availability.defaultProps = {
  availability: '',
}

export default React.memo(Availability)
